import React from "react";
import classNames from "classnames";
import { Link } from "gatsby";
import Markdown from "markdown-to-jsx";

import { VenueCardFragment } from "../../Pages/Map";
import { truncateWords } from "../../../utils/utils";
import styles from "./EventCard.module.scss";
import { CreativeMarkdown } from "../CreativeMarkdown";

export interface EventCardFragment {
  specific: string;
  title: string;
  subtitle?: string;
  description?: string;
  recurring?: boolean;
  image?: {
    publicURL: string;
  };
  link?: string;
  earliest: string;
  venue?: VenueCardFragment;
}

export interface EventCardProps extends EventCardFragment {
  className?: string;
}

const EventCard: React.FC<EventCardProps> = ({
  className,
  title,
  subtitle,
  description,
  venue,
  image,
  link,
}) => {
  return (
    <div className={classNames(styles.outer, className)}>
      <div className={styles.image}>
        <div
          className={styles.imageInner}
          style={{ backgroundImage: `url(${image?.publicURL})` }}
        />
      </div>

      <div className={styles.info}>
        <span className={styles.title}>{title}</span>
        <span className={styles.subtitle}>{subtitle}</span>
        {venue && <span className={styles.venue}>{venue.name}</span>}
        {description && (
          <span className={styles.description}>
            <CreativeMarkdown options={{ forceBlock: true }}>
              {truncateWords(description)}
            </CreativeMarkdown>
          </span>
        )}
        {link && (
          <a
            href={link}
            target="_blank"
            rel="noreferrer noopener"
            className={styles.cta}
          >
            Find out more
          </a>
        )}
        {!link && venue && (
          <Link className={styles.cta} to={venue.slug}>
            Venue info
          </Link>
        )}
      </div>
    </div>
  );
};

export { EventCard };
